import { Injectable } from '@angular/core';
import * as Papa from 'papaparse';

import { BaseService } from './base.service';
import { ListValueModel } from '../model/list-value.model';

interface IWithListByParamOptions {
  integrationOnly?: boolean,
  withAttach?: boolean,
}

@Injectable()
export class ListValueService {

    path = '/list-value';

    constructor(private baseService: BaseService) { }

    post(value: ListValueModel) {
      return this.baseService.post(this.path, '/', value);
    }
  
    put(value: ListValueModel) {
      return this.baseService.put(this.path, '/', value);
    }

    getAll(params) {
      return this.baseService.get(this.path, '/', params);
    }

    getById(id: number) {
      return this.baseService.get(this.path, '/' + id);
    }
  
    delete(id: number) {
      return this.baseService.delete(this.path, '/' + id);
    }
  
    save(value: ListValueModel) {
      if (value.id) { return this.put(value); } else { return this.post(value); }
    }

    getAllWithListByParams(options?: IWithListByParamOptions) {
      return this.baseService.get(this.path, '/' + 'withListByParams', options);
    }

    exportCsv(filters: object) {
      return this.baseService.get(this.path, '/export/csv', filters);
    }

    importCsv(data: any) {
      return this.baseService.put(this.path, '/import/csv', data);
    }

    headerMap = {
      'ID_Easypro': 'id',
      'ID_Externo': 'integration_id',
      'ID_Lista_Relacionada': 'list_id',
      'Descricao': 'description',
      'Excluir': 'deleted_at',
    };

    // convert from csv to json
    importFromCsv(file: File, list_id: number): Promise<any[]> {
      return new Promise((resolve, reject) => {
        if (!file) {
          reject('Nenhum arquivo enviado');
          return;
        }

        const allowedTypes = ['text/csv', 'application/vnd.ms-excel'];
        if (!file.name.endsWith('.csv') || !allowedTypes.includes(file.type)) {
          reject('Formato inválido! Apenas arquivos CSV são permitidos');
          return;
        }

        Papa.parse(file, {
          header: true, skipEmptyLines: true,
          error: (error) => reject(`Erro ao processar CSV: ${error && error.message}`),
          complete: (result) => resolve(this.mapCsvToDto(result.data, result.meta.fields, list_id)),
        });

      });
    }

    // map headers to dto format
    mapCsvToDto(data: any[], headers: string[], list_id: number): any[] {
      return data.map((row) => {
        const lvDto = {} as any;

        headers.forEach(header => {
          const dtoKey = this.headerMap[header] || header;
          lvDto[dtoKey] = row[header] || null;
        });

        if (!lvDto.list_id) lvDto.list_id = list_id;

        // validations
        if (!lvDto.id || lvDto.id == '0') lvDto.id = null;
        if (!lvDto.deleted_at || lvDto.deleted_at == '0') lvDto.deleted_at = null;
        if (!lvDto.integration_id || lvDto.integration_id == '0') lvDto.integration_id = null;

        return lvDto;
      });
    }

}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/service/list-value.service.ts